import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function Header() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="app-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <h1>Meditate</h1>
        </Link>
        <nav className="main-nav" aria-label="Main navigation">
          {isAuthenticated ? (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/calculator">Calculator</Link>
              <Link to="/recipes">Recipes</Link>
              <Link to="/ingredients">Ingredients</Link>
              <Link to="/journal">Journal</Link>
              <Link to="/chat">Chat</Link>
              <Link to="/profile">Profile</Link>
              <button onClick={handleLogout} className="nav-button">
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link to="/login">Sign In</Link>
              <Link to="/signup" className="nav-button-primary">
                Get Started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
